"use client";

import { createContext, useContext, useState, useCallback, memo, useMemo } from "react";

import type { NavbarContextType, NavbarProviderProps } from "./types/navbar.types";

// eslint-disable-next-line react-refresh/only-export-components -- exports context alongside provider
export const NavbarContext = createContext<NavbarContextType>({
  value: null,
  toggleMenu: () => {},
  portalRef: undefined,
  mounted: false,
});

// eslint-disable-next-line react-refresh/only-export-components -- exports context alongside provider
export const useNavbar = () => useContext(NavbarContext);

export const NavbarProvider: React.FC<NavbarProviderProps> = memo((props) => {
  const { children, onValueChange, portalRef, mounted } = props;

  const [menuId, setMenuId] = useState<string | null>(null);

  const toggleMenu = useCallback(
    (id: string | null) => {
      const newValue = id === menuId || !id ? null : id;
      setMenuId(newValue);
      onValueChange?.(newValue);
    },
    [menuId, onValueChange],
  );

  const contextValue = useMemo(
    () => ({
      value: menuId,
      toggleMenu,
      portalRef,
      mounted,
    }),
    [menuId, toggleMenu, portalRef, mounted],
  );

  return <NavbarContext.Provider value={contextValue}>{children}</NavbarContext.Provider>;
});
